import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReportService from '../services/reportService';

function ScheduleReportPage() {
  const navigate = useNavigate();
  const [schedulerName, setSchedulerName] = useState('');
  const [frequency, setFrequency] = useState('daily');
  const [time, setTime] = useState('');
  const [day, setDay] = useState(''); // Weekly
  const [date, setDate] = useState(''); // Monthly
  const [exportPDF, setExportPDF] = useState(false);
  const [exportExcel, setExportExcel] = useState(false);

  // Default report data - you can modify this or make it dynamic
  const report = {
    id: 'RPT123',
    title: 'Complaints Report',
    createdAt: '2025-01-17',
    type: 'General',
    departmentId: 5,
    taluka: 'Aheri'
  };

  const handleSchedule = async () => {
    if (!schedulerName) {
      alert('Please enter scheduler name.');
      return;
    }
    if (!time) {
      alert('Please select time.');
      return;
    }

    // Build payload as per API requirements
    const payload = {
      schedulerName,
      reportId: report?.id,
      reportType: report?.type || 'General',
      frequency: frequency.toUpperCase(),
      scheduledTime: time + ':00',
      enabled: true,
      departmentId: report?.departmentId || 5,
      taluka: report?.taluka || 'Aheri',
      status: 'PENDING',
      exportPDF,
      exportExcel,
    };

    if (frequency === 'weekly') {
      payload.day = day;
    }
    if (frequency === 'monthly') {
      payload.date = date;
    }

    try {
      await ReportService.scheduleReport(payload);
      alert('Report scheduled successfully!');
      navigate('/admin'); // Navigate back to admin page
    } catch (error) {
      alert('Failed to schedule report: ' + error.message);
    }
  };

  const handleBack = () => {
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-4">
              <button
                onClick={handleBack}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <div>
                <h1 className="text-xl font-semibold text-gray-900">
                  Schedule Report
                </h1>
                <p className="text-sm text-gray-500">
                  Configure automated report scheduling
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Report Info */}
        <div className="bg-white rounded-lg shadow mb-8">
          <div className="px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">
              Schedule Report: {report?.title || 'Report'}
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              Configure frequency and timing for automated scheduling
            </p>
          </div>
        </div>

        {/* Layout */}
        <div className="flex bg-gray-50 rounded-lg shadow flex-col lg:flex-row">
          {/* Sidebar - Report Details */}
          <div className="w-full lg:w-80 bg-white p-6 border-r-0 lg:border-r border-gray-200 border-b lg:border-b-0 rounded-l-lg">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-3 flex items-center justify-center">
                <svg
                  className="w-8 h-8 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900">
                {report?.title || 'Report'}
              </h3>
              <p className="text-sm text-gray-500">Ready for scheduling</p>
            </div>

            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-500">
                  Report ID
                </label>
                <p className="text-sm text-gray-900 font-medium">
                  {report?.id}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-500">
                  Created On
                </label>
                <p className="text-sm text-gray-900">{report?.createdAt}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-500">
                  Type
                </label>
                <p className="text-sm text-gray-900">
                  {report?.type || 'General'}
                </p>
              </div>
            </div>
          </div>

          {/* Main Form */}
          <div className="flex-1 p-6 space-y-6 bg-white rounded-r-lg">
            <div className="bg-white rounded-lg shadow border-l-4 border-blue-500">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">
                  Schedule Report
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  Set scheduler name, frequency and timing
                </p>
              </div>
              <div className="p-6 space-y-4">
                {/* Scheduler Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Scheduler Name
                  </label>
                  <input
                    type="text"
                    value={schedulerName}
                    onChange={(e) => setSchedulerName(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter scheduler name"
                  />
                </div>

                {/* Frequency */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Frequency
                  </label>
                  <select
                    value={frequency}
                    onChange={(e) => setFrequency(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </div>

                {/* Weekly */}
                {frequency === 'weekly' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Day of Week
                    </label>
                    <select
                      value={day}
                      onChange={(e) => setDay(e.target.value)}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Select Day</option>
                      <option value="monday">Monday</option>
                      <option value="tuesday">Tuesday</option>
                      <option value="wednesday">Wednesday</option>
                      <option value="thursday">Thursday</option>
                      <option value="friday">Friday</option>
                      <option value="saturday">Saturday</option>
                      <option value="sunday">Sunday</option>
                    </select>
                  </div>
                )}

                {/* Monthly */}
                {frequency === 'monthly' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Date of Month
                    </label>
                    <input
                      type="number"
                      min="1"
                      max="31"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                )}

                {/* Time */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Time
                  </label>
                  <input
                    type="time"
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>

               {/* Export Options */}
<div className="mt-4">
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Export Options
  </label>

  <div className="flex flex-col sm:flex-row gap-3">
    {/* Excel */}
    <label className="inline-flex items-center space-x-2">
      <input
        type="checkbox"
        checked={exportExcel}
        onChange={(e) => setExportExcel(e.target.checked)}
        className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
      />
      <span className="text-sm text-gray-700">Export to Excel</span>
    </label>

    {/* PDF */}
    <label className="inline-flex items-center space-x-2">
      <input
        type="checkbox"
        checked={exportPDF}
        onChange={(e) => setExportPDF(e.target.checked)}
        className="h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
      />
      <span className="text-sm text-gray-700">Export to PDF</span>
    </label>

    {/* ✅ Both */}
    <label className="inline-flex items-center space-x-2">
      <input
        type="checkbox"
        checked={exportPDF && exportExcel}
        onChange={(e) => {
          const checked = e.target.checked;
          setExportPDF(checked);
          setExportExcel(checked);
        }}
        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
      />
      <span className="text-sm text-gray-700">Both</span>
    </label>
  </div>
</div>

              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex gap-4 justify-end">
              <button
                onClick={handleBack}
                className="px-6 py-2 rounded-lg text-sm font-medium border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleSchedule}
                className="px-6 py-2 rounded-lg text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                disabled={!schedulerName || !time}
              >
                Schedule Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleReportPage;

